import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Payslip, PayslipCreate, PayslipFilter } from '../data/payslip';

export function createPayslipService(client: AxiosInstance) {
  return createCrudService<Payslip, PayslipCreate, PayslipFilter>(
    client,
    '/hrm/Payslip',
    'id',
  );
}

export type PayslipService = CrudService<Payslip, PayslipCreate, PayslipFilter>;
